import { render, staticRenderFns } from "./FactScheduleTab.vue?vue&type=template&id=bef1a78c&scoped=true&"
import script from "./FactScheduleTab.vue?vue&type=script&lang=js&"
export * from "./FactScheduleTab.vue?vue&type=script&lang=js&"
import style0 from "./FactScheduleTab.vue?vue&type=style&index=0&id=bef1a78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef1a78c",
  null
  
)

export default component.exports